import React, { FC } from 'react';
import FormModal from '@/components/modals/FormModal';
import copyIcon from '@/assets/icons/copyIcon.svg';
import tickIcon from '@/assets/icons/tickIcon.svg';

interface GeneratedLinkModalProps {
    isOpen: boolean;
    onClose: () => void;
    checkoutLink: string;
    linkCopied: boolean;
    onCopy: () => void;
}

const GeneratedLinkModal: FC<GeneratedLinkModalProps> = ({
    isOpen,
    onClose,
    checkoutLink,
    linkCopied,
    onCopy,
}) => {
    return (
        <FormModal
            overflow='overflow-hidden'
            modalTitle='Generated Link'
            isOpen={isOpen}
            onClose={onClose}
            width='lg:w-1/3 md:w-5/6 w-full'
        >
            <div>
                <h1 className='font-semibold text-sm mt-2'>
                    Checkout Link for Booking
                </h1>
                <div className='relative'>
                    <input
                        disabled
                        value={checkoutLink}
                        maxLength={21}
                        className='w-full px-4 py-3 mt-6 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600 placeholder:text-[12px]'
                        placeholder={'Click on generate link'}
                    />
                    <button
                        type='button'
                        onClick={onCopy}
                        className='absolute inset-y-0 right-3 top-6 flex items-center text-gray-400 hover:text-gray-600'
                    >
                        {linkCopied ? (
                            <img
                                src={tickIcon}
                                alt='copy icon'
                                className='w-7 bg-white rounded-full'
                            />
                        ) : (
                            <img src={copyIcon} alt='copy icon' className='w-7' />
                        )}
                    </button>
                </div>
            </div>
        </FormModal>
    );
};

export default GeneratedLinkModal;
